module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAATJJREFUeF7tlmsKwkAMhDcn06PoydSTRha2IIVKoXlMyPR3CZkvM5vIaP5Jc/2DAOiA5gQYgeYG4CPICDACzQkwAs0NwC3ACDACzQkwAs0NwC3ACKBEQFUfY4ybiDwje4JwwBL/WsLfkRDSAezEb8MPg4AKYIIIgZAOYCo9cEEIBAgAmRBgAGRBgAKQAQEOQDQEMwCqqkEHjOl2qAjAdDtUBfARkXk6X/4qAjATP+mZAbg8ip8Cfw4jU/GQACLFwwGIFg8FIEM8DIAs8RAAMsUjAzB/7Y+2FMQa3LkgTDyEA7bJLAh3qwvv7F0C4YCzzXr8RwAeVCvVpAMqTcujVzrAg2qlmnRApWl59EoHeFCtVJMOqDQtj17pAA+qlWrSAZWm5dErHeBBtVJNOqDStDx6/QL60WxBtdG3JwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/honor_system/arrows-right.png
// module id = DGBs
// module chunks = 15